export const searchLink = '/help/search.html';
export const phoneNumbers = {
  annualCreditReport: '1-877-322-8228',
  experianSmartMoneyCustomerServiceTollFree: '(833) 804-0770', 
  experianSmartMoneyCustomerServiceInternational: '+1 (479) 343-6242'
};
